import { ScrollArea } from '@neo/primitives/scroll-area'
import { useOrgStatusQuery } from 'v2/pages/settings/org-status/queries'
import { StatusItem } from './status-item'

export const StatusMenu = () => {
  const { data: status } = useOrgStatusQuery()
  const statusOptions = status || []

  return (
    <ScrollArea className="[&>[data-radix-scroll-area-viewport]]:max-h-40">
      {statusOptions.map((s) => (
        <StatusItem key={s.uuid} s={s} />
      ))}
    </ScrollArea>
  )
}
